import { Command, Transaction } from "prosemirror-state";
import { MentionInputSuggestion } from "../MentionInput";
import { mentionInputSchema } from "../schema";
import { MentionNodeAttributes } from "../schema/nodes/mention";

export function insertSuggestion(
	from: number,
	to: number,
	type: string,
	suggestion: MentionInputSuggestion
): Command {
	return (state, dispatch): boolean => {
		if (dispatch) {
			const tr: Transaction = state.tr;

			const attrs: MentionNodeAttributes = {
				type,
				value: suggestion.data,
				label: suggestion.text,
				isStale: false
			};

			const {
				mention
			} = mentionInputSchema.nodes;

			tr.replaceWith(
				from,
				to,
				[
					mention.create(attrs),
				]
			);

			dispatch(tr.scrollIntoView());
		}

		return true;
	};
}